//common components
import Banner from "egov-ui-kit/common/common/Banner";
import CityPicker from "egov-ui-kit/common/common/CityPicker";
import ErrorScreen from "egov-ui-kit/common/common/ErrorScreen";
import Footer from "egov-ui-kit/common/common/Footer";
import Header from "egov-ui-kit/common/common/Header";
import ImageModalDisplay from "egov-ui-kit/common/common/ImageModalDisplay";
import ImageUpload from "egov-ui-kit/common/common/ImageUpload";
import RenderRoutes from "egov-ui-kit/common/common/RenderRoutes";
import SuccessMessage from "egov-ui-kit/common/common/SuccessMessage";
import TrackLocation from "egov-ui-kit/common/common/TrackLocation";
import VerticalCenterWrapper from "egov-ui-kit/common/common/VerticalCenterWrapper";
import Screen from "egov-ui-kit/common/common/Screen";
import ActionMenu from "egov-ui-kit/common/common/ActionMenu";
import ActionFooter from "egov-ui-kit/common/common/ActionFooter";
import PrivacyPolicy from "egov-ui-kit/common/common/PrivacyPolicy";
import OnlinePayment from "egov-ui-kit/common/common/OnlinePayment";
import OnlinePaymentRedirect from "egov-ui-kit/common/common/OnlinePayment/paymentRedirectPage";
import PaymentAcknowledgement from "egov-ui-kit/common/common/OnlinePayment/acknowledgement";
import Dashboard from "egov-ui-kit/common/common/Dashboard";
import ModuleLandingPage from "egov-ui-kit/common/common/ModuleLandingPage";
import Notifications from "egov-ui-kit/common/common/Notifications";
import EventDetails from "egov-ui-kit/common/common/Notifications/components";

//pgr common components
import ComplaintSubmited from "egov-ui-kit/common/pgr/ComplaintSubmited";
import ActionButton from "egov-ui-kit/common/pgr/complaintDetails/components/ActionButton";
import Comments from "egov-ui-kit/common/pgr/complaintDetails/components/Comments";
import ComplaintTimeLine from "egov-ui-kit/common/pgr/complaintDetails/components/ComplaintTimeLine";
import Details from "egov-ui-kit/common/pgr/complaintDetails/components/Details";
import WriteComment from "egov-ui-kit/common/pgr/complaintDetails/components/WriteComment";
import Complaints from "egov-ui-kit/common/pgr/Complaints";
import FeedbackPopup from "egov-ui-kit/common/pgr/FeedbackPopup";
import Question from "egov-ui-kit/common/pgr/ReOpenComplaint/components/Question";
import TextArea from "egov-ui-kit/common/pgr/ReOpenComplaint/components/TextArea";
import ReOpenComplaint from "egov-ui-kit/common/pgr/ReOpenComplaint";
import ReopenAcknowledgement from "egov-ui-kit/common/pgr/ReopenAcknowledgement";
import ComplaintType from "egov-ui-kit/common/pgr/ComplaintType";

//User common components
import LanguageSelectionForm from "egov-ui-kit/common/User/components/LanguageSelectionForm";
import OTPForm from "egov-ui-kit/common/User/components/OTPForm";
import ProfileForm from "egov-ui-kit/common/User/components/ProfileForm";
import ProfileSection from "egov-ui-kit/common/User/components/ProfileSection";
import UploadDrawer from "egov-ui-kit/common/User/components/UploadDrawer";

//Pt common components
import AssessPay from "egov-ui-kit/common/propertyTax/AssessPay";
import AssessmentList from "egov-ui-kit/common/propertyTax/AssessmentList";
import YearDialogue from "egov-ui-kit/common/propertyTax/YearDialogue";
import Property from "egov-ui-kit/common/propertyTax/Property";
import SingleProperty from "egov-ui-kit/common/propertyTax/SingleProperty";

export {
  Banner,
  CityPicker,
  ErrorScreen,
  EventDetails,
  Footer,
  Header,
  ImageModalDisplay,
  ImageUpload,
  RenderRoutes,
  SuccessMessage,
  TrackLocation,
  VerticalCenterWrapper,
  Screen,
  ActionButton,
  Comments,
  ComplaintTimeLine,
  Details,
  WriteComment,
  LanguageSelectionForm,
  OTPForm,
  ProfileForm,
  ProfileSection,
  UploadDrawer,
  Complaints,
  FeedbackPopup,
  Question,
  TextArea,
  ActionMenu,
  ActionFooter,
  ComplaintType,
  ReOpenComplaint,
  ReopenAcknowledgement,
  ComplaintSubmited,
  PrivacyPolicy,
  OnlinePayment,
  //   OnlinePaymentPage,
  AssessPay,
  Dashboard,
  AssessmentList,
  YearDialogue,
  Property,
  ModuleLandingPage,
  SingleProperty,
  Notifications,
  OnlinePaymentRedirect,
  PaymentAcknowledgement,
};



// WEBPACK FOOTER //
// ./src/modules/common/index.js